import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "pwd_reissue"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "f_pass w60" };
const _hoisted_6 = {
    key: 0,
    class: "err"
};
const _hoisted_7 = { class: "f_pass w60" };
const _hoisted_8 = {
    key: 0,
    class: "err"
};
import { watch, onUnmounted } from 'vue';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
export default /*@__PURE__*/ _defineComponent({
    __name: 'pwd_reissue',
    props: {
        common: {},
        errors: {},
        email: {},
        token: {}
    },
    setup(__props) {
        const props = __props;
        const form = InertiaUtil.getForm({
            token: props.token,
            email: props.email,
            password: '',
            password_confirmation: '',
        });
        // 文字数チェック
        watch(() => form.password, (value) => {
            if (Alert.charLimitText(value)) {
                form.password = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.password_confirmation, (value) => {
            if (Alert.charLimitText(value)) {
                form.password_confirmation = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        // 編集チェック
        watch(() => form, () => PageExitConfirm.addEvent(), { deep: true });
        const onSubmit = () => {
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('reset_password.store'));
        };
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[10] || (_cache[10] = _createElementVNode("h2", null, "パスワード再設定", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _cache[9] || (_cache[9] = _createElementVNode("p", null, [
                                    _createTextVNode("パスワードを再発行します。"),
                                    _createElementVNode("br", { class: "sp" }),
                                    _createTextVNode("新しいパスワードを入力してください。")
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onSubmit, ["prevent"])
                                }, [
                                    _createElementVNode("dl", null, [
                                        _cache[5] || (_cache[5] = _createElementVNode("dt", null, "メール", -1)),
                                        _createElementVNode("dd", null, _toDisplayString(props.email), 1),
                                        _cache[6] || (_cache[6] = _createElementVNode("dt", null, "新パスワード", -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).password) = $event)),
                                                    class: "wmax",
                                                    type: "password",
                                                    id: "textPassword_1",
                                                    placeholder: "半角英数字12文字以上"
                                                }, null, 512), [
                                                    [_vModelText, _unref(form).password]
                                                ]),
                                                _cache[2] || (_cache[2] = _createElementVNode("span", {
                                                    id: "buttonEye_1",
                                                    class: "fa fa-eye",
                                                    onclick: "pushHideButton(1)"
                                                }, null, -1))
                                            ]),
                                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "allert" }, "※半角英数字12文字以上", -1)),
                                            ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.password)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(props.errors.password), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _cache[7] || (_cache[7] = _createElementVNode("dt", null, "確認用パスワード", -1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_7, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).password_confirmation) = $event)),
                                                    class: "wmax",
                                                    type: "password",
                                                    id: "textPassword_2",
                                                    placeholder: "再パスワードを入力"
                                                }, null, 512), [
                                                    [_vModelText, _unref(form).password_confirmation]
                                                ]),
                                                _cache[4] || (_cache[4] = _createElementVNode("span", {
                                                    id: "buttonEye_2",
                                                    class: "fa fa-eye",
                                                    onclick: "pushHideButton(2)"
                                                }, null, -1))
                                            ]),
                                            ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.password_confirmation)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(props.errors.password_confirmation), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "bt_box" }, [
                                        _createElementVNode("button", {
                                            type: "submit",
                                            id: "submit-button",
                                            class: "b_max"
                                        }, " パスワードを再設定してログイン ")
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
